import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import axios from "axios";

const Chatbot = () => {
  const { t } = useTranslation();
  const [isChatBotVisible, setIsChatBotVisible] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);
  const [animationType, setAnimationType] = useState("slideIn");
  const [messages, setMessages] = useState([
    {
      content: t("features.chatbot.subtitle"),
      isBot: true,
    },
    {
      content: t("features.chatbot.msg"),
      isBot: true,
    },
  ]);
  const [inputQuestion, setInputQuestion] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const messagesEndRef = useRef(null);
  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);
  const toggleChatbotVisibility = () => {
    if (isChatBotVisible) {
      setAnimationType("slideOut");
      setIsAnimating(true);
      setTimeout(() => {
        setIsChatBotVisible(false);
        setIsAnimating(false);
      }, 500);
    } else {
      setIsChatBotVisible(true);
      setAnimationType("slideIn");
      setIsAnimating(true);
      setTimeout(() => {
        setIsAnimating(false);
      }, 500);
    }
  };
  const handleSendMessage = async () => {
    if (!inputQuestion.trim()) {
      return;
    }

    setError("");
    const userMessage = { content: inputQuestion, isBot: false };
    setMessages((prev) => [...prev, userMessage]);
    setInputQuestion("");
    setIsLoading(true);
    try {
      const { data } = await axios.post(
        `${process.env.REACT_APP_PYTHON_URL}/ask_about_apollo`,
        { question: inputQuestion },
        { headers: { "Content-Type": "application/json" } }
      );

      const botMessage = { content: data.response, isBot: true };
      setMessages((prev) => [...prev, botMessage]);
    } catch (err) {
      setError("There was an issue , Try Again!");
      console.error("API Error:", err);
    } finally {
      setIsLoading(false);

    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter" && !isLoading) {
      handleSendMessage();
    }
  };
  return (
    <div className="bot-main relative z-[4]">
      <img
        src={
          isChatBotVisible
            ? "../../assets/images/home/bot-open.png"
            : "../../assets/images/home/bot-cross.png"
        }
        alt="Toggle Chatbot"
        className={`fixed cursor-pointer right-[11%] bottom-[2%] max-xxxl:right-[5%] z-[9999] ${
          isAnimating
            ? isChatBotVisible
              ? "animate-[rotateOut_0.5s_ease-in-out]"
              : "animate-[rotateIn_0.5s_ease-in-out]"
            : ""
        }`}
        onClick={toggleChatbotVisibility}
      />

      {(isChatBotVisible || isAnimating) && (
        <div
          className={`chatbot-container botback w-[278px] z-[999999] h-fit fixed rounded-[28px] right-[11%] max-xxxl:right-[5%] ${
            isChatBotVisible
              ? "bottom-[13%] max-xxxl:bottom-[16%]"
              : "bottom-[-100%]"
          } z-[999] ${
            isAnimating
              ? animationType === "slideIn"
                ? "animate-[slideIn_0.5s_ease-in-out]"
                : "animate-[slideOut_0.5s_ease-in-out]"
              : ""
          }`}
          style={{
            display: isChatBotVisible || isAnimating ? "block" : "none",
          }}
        >
          <div className="top bg-darkblue rounded-t-[11px] py-[20px] px-[28px]">
            <p className="text-white font-inter medium">
              {t("features.chatbot.title")}
            </p>
          </div>
          <div className="chat pt-[14px] pr-[18px] pl-[28px] pb-[5px] flex flex-col gap-[8px] h-[390px] overflow-y-auto">
            {messages.map((message, index) => (
              <div
                key={index}
                className={`p-[7px] rounded-[4px] dropBoxshadow max-w-[217px] w-fit ${
                  message.isBot
                    ? "bg-[#FDFDFD]"
                    : "bg-darkblue text-white ml-auto"
                }`}
              >
                <p className="font-inter small">{message.content}</p>
              </div>
            ))}
            {isLoading && (
              <div className="flex items-center gap-1 p-[7px] rounded-[4px] bg-darkblue text-white max-w-[217px] w-fit">
                <div className="w-2 h-2 bg-white rounded-full animate-[bounce_1s_infinite_100ms]" />
                <div className="w-2 h-2 bg-white rounded-full animate-[bounce_1s_infinite_200ms]" />
                <div className="w-2 h-2 bg-white rounded-full animate-[bounce_1s_infinite_300ms]" />
              </div>
            )}
            <div ref={messagesEndRef} />
          </div>
          {error && <p className="text-red-500 text-xs px-4">{error}</p>}
          <div className="message-div p-[6px] flex items-center gap-[6px] mt-[10px]">
            <input
              type="text"
              value={inputQuestion}
              onChange={(e) => setInputQuestion(e.target.value)}
              onKeyDown={handleKeyPress}
              placeholder={t("features.chatbot.inputPlaceholder")}
              className="bg-[#E8E8E8] rounded-[17px] p-[9px] w-full text-[#6A6A6A] font-inter text-[12px]"
            />
            <button
              onClick={handleSendMessage}
              disabled={isLoading}
              className="..."
            >
              <img
                src="../../assets/icons/Hammer.png"
                alt="Send"
                className="w-[30px] h-[30px] cursor-pointer"
              />
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Chatbot;
